import Backbone from 'backbone-model';

import GroupMemberships from 'collections/GroupMemberships';
import Avatar from 'entities/Avatar';
import Group, { SubscribeInfoType } from 'entities/Group';

// virtual id, not in the database
const rootGroupId = -1;

export const rootGroupCode = 'r';
export default class RootGroup extends Group {
  initialize() {
    this.id = rootGroupId;
  }

  id: number = rootGroupId;

  isRoot() {
    return true;
  }

  getName() {
    // not concerned yet with localization
    return 'All classes';
  }

  getCode() {
    return rootGroupCode;
  }

  getType() {
    return 'root';
  }

  isStaffClass() {
    return false;
  }

  canAddPeople() {
    return false;
  }

  canJoin() {
    return false;
  }

  canEdit() {
    return false;
  }

  canLeave() {
    return false;
  }

  /**
   * @deprecated. Use postable roles instead.
   */
  canPost() {
    return true;
  }

  getPostableRoles() {
    return [];
  }

  canDelete() {
    return false;
  }

  isSMSEnabled() {
    return false;
  }

  hasShortCode() {
    return false;
  }

  isAvailable() {
    return false;
  }

  isSubscribed() {
    return false;
  }

  isOwnedByUser() {
    return false;
  }

  getPermissions() {
    return {};
  }

  getAvatarUrl() {
    return require('assets/images/avatars/home.svg');
  }

  getAccentColor() {
    return '#2f75c1';
  }

  getOwners = () => {
    throw new Error('unsupported operation for RootGroup');
  };

  setName() {
    throw new Error('unsupported operation for RootGroup');
  }

  getPdfUrl() {
    return ''; // TODO: Where is this invoked?
  }

  getJoinUrl = () => {
    throw new Error('unsupported operation for RootGroup');
  };

  hasChildren = () => {
    throw new Error('unsupported operation for RootGroup');
  };

  setHasChildren() {
    throw new Error('unsupported operation for RootGroup');
  }

  getMembershipsCount() {
    return 0; // TODO: Where is this invoked?
  }

  getSubscriptionInfo(): SubscribeInfoType {
    throw new Error('unsupported operation for RootGroup');
  }

  useShortCodeForUser(): boolean | undefined {
    throw new Error('unsupported operation for RootGroup');
  }

  smsEnabledForUser(): boolean | undefined {
    throw new Error('unsupported operation for RootGroup');
  }

  getStaffClassOrgId() {
    return null;
  }

  getOrganization() {
    return undefined;
  }

  setOrganization() {
    throw new Error('unsupported operation for RootGroup');
  }

  getMessagesCount(): number {
    throw new Error('unsupported operation for RootGroup');
  }

  getLastReadSeq(): number | undefined {
    throw new Error('unsupported operation for RootGroup');
  }

  canSubscribersInitiateChats(): boolean {
    throw new Error('unsupported operation for RootGroup');
  }

  setCanSubscribersInititateChats() {
    throw new Error('unsupported operation for RootGroup');
  }

  getPossessiveName(): string {
    throw new Error('unsupported operation for RootGroup');
  }

  getSMSNumber(): string {
    throw new Error('unsupported operation for RootGroup');
  }

  getSMSAlternateNumber(): string {
    throw new Error('unsupported operation for RootGroup');
  }

  getEmail(): string {
    throw new Error('unsupported operation for RootGroup');
  }

  isSearchable() {
    return true;
  }

  setSearchable(): Backbone.Model {
    throw new Error('unsupported operation for RootGroup');
  }

  getAvatar(): Avatar | undefined {
    throw new Error('unsupported operation for RootGroup');
  }

  getAvatarId(): number | undefined {
    throw new Error('unsupported operation for RootGroup');
  }

  setAvatar() {
    throw new Error('unsupported operation for RootGroup');
  }

  setLastReadSeq() {
    throw new Error('unsupported operation for RootGroup');
  }

  getUserId() {
    throw new Error('unsupported operation for RootGroup');
  }

  getUserSignature() {
    throw new Error('unsupported operation for RootGroup');
  }

  getState(): string {
    throw new Error('unsupported operation for RootGroup');
  }

  setState() {
    throw new Error('unsupported operation for RootGroup');
  }

  loadPotentialOwners(): Promise<GroupMemberships> {
    throw new Error('unsupported operation for RootGroup');
  }

  loadGroupMemberships(): Promise<GroupMemberships> {
    throw new Error('unsupported operation for RootGroup');
  }

  promoteGroupMemberships(): Promise<GroupMemberships> {
    throw new Error('unsupported operation for RootGroup');
  }

  resignOwnership(): Promise<Group> {
    throw new Error('unsupported operation for RootGroup');
  }

  removeMember(): Promise<void> {
    throw new Error('unsupported operation for RootGroup');
  }

  removeAllMembers() {
    throw new Error('unsupported operation for RootGroup');
  }

  addSubscribers(): Promise<GroupMemberships> {
    throw new Error('unsupported operation for RootGroup');
  }

  subscribe(): Promise<Group> {
    throw new Error('unsupported operation for RootGroup');
  }

  unsubscribe(): Promise<void> {
    throw new Error('unsupported operation for RootGroup');
  }
}

export const rootGroup = new RootGroup();
